// useDownloadFile.ts
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

/**
 * Downloads an image by S3 key.
 * Expects the backend endpoint to return an object with a `url` property.
 */
const downloadFile = async (key: string): Promise<string> => {
  const response = await axios.get<{ url: string }>(`${baseUrl}/aws/s3/download-file`, { params: { key } })
  return response.data.url
}

/**
 * Custom hook for downloading an image.
 */
export const useDownloadFile = (): UseMutationResult<string, unknown, string, unknown> => {
  return useMutation<string, unknown, string>({
    mutationFn: downloadFile,
    onSuccess: data => {
      console.log('Success!')
    },
  })
}
